import React from 'react';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import UserRow from '../../components/common/rows/userRow';
import authService from '../../services/api/auth';
import { TableContainerComponent } from 'src/assets/styles/components/Table';
import {
  AdminTableNetworkSection,
  AdminTableContent,
} from 'src/assets/styles/components/AdminTable';

const AllUsers = (props) => {
  const [allUsers, set_allUsers] = React.useState([]);
  const [loading, set_loading] = React.useState(true);

  React.useEffect(() => {
    getUsers();
  }, []);

  function getUsers() {
    set_loading(true);

    authService
      .getAllUsers()
      .then((response) => {
        set_loading(false);
        if (response.data.success) {
          set_allUsers(response.data.allUsers);
        }
      })
      .catch((error) => {
        if (error.response) Swal.fire(error.response.data.message);
        set_loading(false);
      });
  }

  return (
    <AdminTableNetworkSection>
      <AdminTableContent>
        <h2>Directorio de usuarios de App Comunidad MDE</h2>
      </AdminTableContent>

      <TableContainerComponent>
        <table>
          <thead>
            <tr>
              <th>Nombre</th>
              <th>Usuario</th>
              <th>Ver</th>
            </tr>
          </thead>
          <tbody>
            {allUsers.map((user) => (
              <UserRow getUsers={getUsers} user={user} history={props.history} />
            ))}
            {loading && <p>Cargando</p>}
          </tbody>
        </table>
      </TableContainerComponent>
    </AdminTableNetworkSection>
  );
};

export default AllUsers;
